
import React, { Component } from 'react'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import Numeral from 'numeral'

import {List, ListItem} from 'material-ui/List'
import SelectField from 'material-ui/SelectField'

import { dirtyRead, doc } from 'selectors/common'
import { getMonth, getTimezoneDate } from 'utils/date'

let select = dirtyRead(
	(state, props) => {
		return {
			termDoc: doc(state, props.termID)
		}
	}
)

export class TermCard extends Component {
	render(){
		let { props } = this
			return(
				<Link
					className="vandor-card"
					to={`/manager/term/${props.termID}`}
					style={{
						textDecoration: 'none'
					}}
				>
					<ListItem
						style={{
							overflow: 'hidden'
						  , paddingLeft: (typeof global.md.phone() == 'string')?"10px":"0"
						  , marginLeft: (typeof global.md.phone() != 'string')?"0":undefined
						  , margin: "0"
						  , textOverflow: "ellipsis"
						}}
						innerDivStyle={{
							padding: "0 15px"
						}}
						className="list-hover"
						key = {props.term._id}
					>

						<p style={{width: "100%"}}>
							<p style={{
								fontSize: "16px"
							  , textOverflow: "ellipsis"
							  , whiteSpace: "nowrap"
							  , overflow: "hidden"
							  , margin: "0"
							  , marginRight: "4%"
							  , width: '30%'
							  , float: "left"
							  , display:"inline-block"
							  , fontWeight: props.term.main ? "none" : "none"
							}}>
								{props.term.dateFrom?`${getTimezoneDate(props.term.dateFrom).getDate()} ${getMonth(getTimezoneDate(props.term.dateFrom).getMonth())} ${getTimezoneDate(props.term.dateFrom).getFullYear()}`:""}
							</p>
							<p style={{
								fontSize: "16px"
							  , textOverflow: "ellipsis"
							  , whiteSpace: "nowrap"
							  , overflow: "hidden"
							  , margin: "0"
							  , width: '30%'
							  , height: "15px"
							  , display:"inline-block"
							  , textAlign:"left"
							}}>

								<span style={{fontWeight: props.term.main ? "none" : "none"}}>
									{props.term.dateTill?`${getTimezoneDate(props.term.dateTill).getDate()} ${getMonth(getTimezoneDate(props.term.dateTill).getMonth())} ${getTimezoneDate(props.term.dateTill).getFullYear()}`:""}
								</span>
							</p>
							<p style={{
								  fontSize: "16px"
								, textOverflow: "ellipsis"
								, whiteSpace: "nowrap"
								, overflow: "hidden"
								, margin: "0"
  							    , marginLeft: "1%"
								, width: '30%'
								, display:"inline-block"
								, float:"right"
								, textAlign:"right"
						    }}>
								<span style={{fontWeight: props.term.main ? "none" : "none"}}>
									${Numeral(props.term.rent).format('0.00')}
								</span>
							</p>
						</p>
					</ListItem>
				</Link>
			)
	}

}
export default connect(select)(TermCard)



// WEBPACK FOOTER //
// ./src/routes/manager/leaseForm/TermCard.js